import { AbstractControl, ValidatorFn } from "@angular/forms";

export function markedDuplicateValidator(duplicateValue: any): ValidatorFn {
    return (control: AbstractControl) => {
        if(duplicateValue == control.value) {
            return {markedDuplicate: true}
        }

        return null;
    }
}

export function matchToOtherControlValidator(otherControlName: string): ValidatorFn {
    return (control: AbstractControl) => {
        const otherControl = control.parent.get(otherControlName);
        return control && otherControl && control.value != otherControl.value
        ? {notMatching: true} : null;
    }
}

// Like Validators.required, but a value made up only of whitespace also counts as missing.
export function requiredTrimmedValidator(): ValidatorFn {
    return (control: AbstractControl) => {
        const value = control.value;
        return value == null || String(value).trim().length === 0 ? {required: true} : null;
    }
}

export function yearRangeValidator(startControlName: string, endControlName: string): ValidatorFn {
    return (group: AbstractControl) => {
        const start = group.get(startControlName)?.value;
        const end = group.get(endControlName)?.value;
        return start && end && start > end ? {invalidYearRange: true} : null;
    }
}
